import { isPlatform } from '@ionic/core';
import { Components } from '@ionic/core/dist/types/components';
import { IonToggle } from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import { ReactElement, useRef } from 'react';
import { IonItem } from '../ionic/IonItem';
import { FieldLocked } from '../ui/field-locked';

export interface IonFormSwitchFieldProps extends FieldConfig {
  className?: string;
  label: string;
  inputProps?: Partial<Components.IonToggle>;
}

const IonFormSwitchField = (props: IonFormSwitchFieldProps): ReactElement => {
  const { label, inputProps, ...otherProps } = props;

  const inputRef = useRef<HTMLIonToggleElement>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, _meta, helper] = useField(otherProps as any);

  const isIOS = isPlatform('ios');

  return (
    <IonItem
      lines={'full'}
      className={props.className}
      onClick={async () => {
        if (!isIOS) {
          inputRef.current?.click();
        }
      }}
    >
      <IonToggle
        ref={inputRef}
        checked={field.value}
        onIonChange={(e) => {
          helper.setValue(e.detail.checked);
        }}
        onClick={(e) => e.stopPropagation()}
        {...inputProps}
      >
        {label} <FieldLocked show={inputProps?.disabled ?? false} />
      </IonToggle>
    </IonItem>
  );
};

export { IonFormSwitchField };
